export default __webpack_public_path__ + "static/media/R3.85507668.png";